import { setAdditionalPageInfo, setAuthenticationStatus, setSiteInfo } from './digitalDataBuilder';
import { getAnalyticsAuthenticationStatus } from './thdUserInfo';
import { buildCategoryData } from './commonAnalytics';

const setTheHomeDepotCategoryObject = (omnitureInfo) => {
  const categoryData = buildCategoryData(omnitureInfo);
  setAdditionalPageInfo('category', categoryData);

  const pageInfoData = {
    pageName: 'flooring>carpet>carpet configurator',
    pageType: 'tool:carpet installation:configurator',
  };
  setAdditionalPageInfo('pageInfo', pageInfoData);
};

export const trackEstimatorPageLoad = (omnitureInfo) => {
  setSiteInfo();
  setAdditionalPageInfo('category', buildCategoryData(omnitureInfo));
  setTheHomeDepotCategoryObject(omnitureInfo);
  setAuthenticationStatus(getAnalyticsAuthenticationStatus());
};
